import Vue from 'vue'
import VueRouter from 'vue-router'
// 登录页面
import Login from "../login/Login.vue"
// 登录之后跳转页面
import navigation from "../components/navigation.vue"
import datacenter from "../components/datacenter/datacenter.vue"//数据中心
import xtglwxpart from "../components/xtglwxpart/xtglwxpart.vue"//白名单
import userwxpart from "../components/xtglwxpart/userwxpart.vue"//用户管理
import rolewxpart from "../components/xtglwxpart/rolewxpart.vue"//角色管理
import lfcometovisit from "../components/xtglwxpart/lfcometovisit.vue"//角色管理
import cpproductorder from "../components/cpproductorder/cpproductorder.vue"//订单管理
import cpproductorderdetail from "../components/cpproductorder/cpproductorderdetail.vue"//订单管理详情
import productlist from "../components/productlist/productlist.vue"//产品列表
import producaddtlist from "../components/productlist/producaddtlist.vue"//产品列表添加
import producaddtadetail from "../components/productlist/producaddtadetail.vue"//产品列表详情
import ceshixiangmu from "../components/productlist/ceshixiangmu.vue"//测试测试
import classification from "../components/management/classification.vue"//分类管理
import removefrom from "../components/management/removefrom.vue"//下架产品
import specifications from "../components/management/specifications.vue"//规格配置
import accessories from "../components/accessorieslist/accessories.vue"//配件库
import addaccessories from "../components/accessorieslist/addaccessories.vue"//配件库新增
import adetailsaccessories from "../components/accessorieslist/adetailsaccessories.vue"//配件库详情
import noticegl from "../components/marketivities/noticegl.vue"//公告管理
import postergl from "../components/marketivities/postergl.vue"//海报管理
import language from "../components/marketivities/language.vue"//引导语设置
import carouselsz from "../components/marketivities/carouselsz.vue"//轮播图设置
import qymanager from "../components/xtglwxpart/qymanager.vue"//角色管理
// carouselsz
Vue.use(VueRouter)
const router = new VueRouter({
  // base: '/nkChoose',
  mode:'hash',
  // hash
  // history
  routes: [
    {
      path:'/',
      name:'Login',
      component: Login
    },
    {
      path: '/navigation',
      name: 'navigation',
      component: navigation,
      meta:{ authRequired: true },
      redirect:'/datacenter',
      children:[
          {
            path: '/xtglwxpart',
            name: 'xtglwxpart',
            component: xtglwxpart
          },
          {
            path: '/cpproductorder',
            name: 'cpproductorder',
            component: cpproductorder
          },
          {
            path: '/cpproductorderdetail',
            name: 'cpproductorderdetail',
            component: cpproductorderdetail
          },
          {
            path: '/datacenter',
            name: 'datacenter',
            component: datacenter
          },
          {
            path: '/productlist',
            name: 'productlist',
            component: productlist
          },
          {
            path: '/producaddtlist',
            name: 'producaddtlist',
            component: producaddtlist
          },
          {
            path: '/producaddtadetail',
            name: 'producaddtadetail',
            component: producaddtadetail
          },
          {
            path: '/ceshixiangmu',
            name: 'ceshixiangmu',
            component: ceshixiangmu
          },
          {
            path: '/classification',
            name: 'classification',
            component: classification
          },
          {
            path: '/removefrom',
            name: 'removefrom',
            component: removefrom
          },
          {
            path: '/specifications',
            name: 'specifications',
            component: specifications
          },
          {
            path: '/accessories',
            name: 'accessories',
            component: accessories
          },
          {
            path: '/noticegl',
            name: 'noticegl',
            component: noticegl
          },
          {
            path: '/postergl',
            name: 'postergl',
            component: postergl
          },
          {
            path: '/language',
            name: 'language',
            component: language
          },
          {
            path: '/carouselsz',
            name: 'carouselsz',
            component: carouselsz
          },
          {
            path: '/userwxpart',
            name: 'userwxpart',
            component: userwxpart
          },
          {
            path: '/rolewxpart',
            name: 'rolewxpart',
            component: rolewxpart
          },
          {
            path: '/lfcometovisit',
            name: 'lfcometovisit',
            component: lfcometovisit
          },
          {
            path: '/qymanager',
            name: 'qymanager',
            component: qymanager
          },
          {
            path: '/addaccessories',
            name: 'addaccessories',
            component: addaccessories
          },
          {
            path: '/adetailsaccessories',
            name: 'adetailsaccessories',
            component: adetailsaccessories
          },
          
          
      ]
    },
  ]
});
router.beforeEach((to,from,next) => {
  const token = localStorage.getItem('token')
  if(to.name!=='Login'&& !token) next({ name: 'Login'})
  else next()
})
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js